'use client';

import { Button } from '@/components/button';
import { SOCIAL_LINKS } from '@/utils/constants';

export const SocialButtons = () => (
  <>
    {SOCIAL_LINKS.map((item: any, index: number) => (
      <Button href={item.href} key={item.label} className="group p-2.5" size="">
        <item.icon className="size-6 translate-x-0 transition-all group-hover:-translate-x-8" />
        <item.icon className="absolute top-0 z-10 size-6 translate-x-8 transition-all group-hover:translate-x-0" />
      </Button>
    ))}
  </>
);
